import { apiFetch } from './client.js';

export interface AIAnalysis {
  entidad: string | null;
  licitacionNum: string | null;
  tipoLicitacion: string | null;
  /** Pública o privada según QUIÉN CONTRATA (no el procedimiento). Decide el modelo de
   *  costo del equipo, así que no es una etiqueta. */
  tipoObra?: 'publica' | 'privada' | null;
  objetoObra: string | null;
  resumen: string | null;
  fechaApertura: string | null;
  fechaVisita: string | null;
  plazoEjecucion: string | null;
  montoGarantia: string | null;
  moneda: string | null;
  observaciones: string[];
  documentosClave: string[];
}

export interface ObraSummaryFile {
  id: string;
  name: string;
  classification: string;
  sizeKB: number;
  hasText: boolean;
  pages: number | null;
  ocrUsed: boolean;
}

export interface ObraAnalysis {
  schemaVersion: 1;
  generatedAt: string;
  totalFiles: number;
  totalSizeKB: number;
  filesByClass: Record<string, number>;
  filesByExt: Record<string, number>;
  detectedEntity: string | null;
  detectedLicitNum: string | null;
  detectedObjeto: string | null;
  ai: AIAnalysis | null;
  files: ObraSummaryFile[];
  meta: {
    model: string;
    provider: string;
    contextChars: number;
    filesUsedForAi: number;
    durationMs: number;
    aiError?: string | null;
  };
}

export interface ProjectSummary {
  projectId: string;
  status: 'idle' | 'analyzing' | 'ready' | 'failed';
  summaryAt: string | null;
  error: string | null;
  analysis: ObraAnalysis | null;
}

export async function getSummary(projectId: string): Promise<ProjectSummary> {
  return await apiFetch<ProjectSummary>(`/api/v1/projects/${projectId}/summary`);
}

export interface RegenerateResponse {
  projectId: string;
  jobId: string;
  parseableFiles: number;
  status: 'analyzing';
}

/**
 * Detener el resumen que se está generando. La respuesta significa "pedido registrado": el
 * worker aborta la llamada al modelo en su próximo chequeo. NO se guarda nada a medias — el
 * proyecto vuelve a como estaba y el resumen anterior, si había, queda intacto.
 */
export async function stopSummary(projectId: string): Promise<{ ok: boolean; status: string }> {
  return await apiFetch(`/api/v1/projects/${projectId}/summary/stop`, { method: 'POST' });
}

export async function regenerateSummary(projectId: string): Promise<RegenerateResponse> {
  return await apiFetch<RegenerateResponse>(
    `/api/v1/projects/${projectId}/summary/regenerate`,
    { method: 'POST' },
  );
}

export function summaryPrintUrl(projectId: string): string {
  return `/api/v1/projects/${projectId}/summary/print.html`;
}
